import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class AudioPlayerService {
	private _audioElements: { [src: string]: HTMLAudioElement } = {};

	onSuspended = new EventEmitter<string>();

	constructor() {}

	play(src: string, loop: boolean = false) {
		this.element(src).loop = loop;
		this.element(src).volume = 1.0;
		this.element(src).currentTime = 0;
		(this.element(src).play() as any).then(
			(success) => {
				this.onSuspended.emit(null);
			},
			(error: DOMException) => {
				if (error.message.indexOf('Failed to load') === -1) this.onSuspended.emit(src);
			},
		);

		return this.element(src);
	}

	stop(src: string) {
		this.element(src).pause();
		this.onSuspended.emit(null);
	}

	playing(src: string) {
		return typeof this.element(src) === 'undefined' ? false : !this.element(src).paused;
	}

	element(src: string): HTMLAudioElement {
		if (typeof this._audioElements[src] === 'undefined') this.createElement(src);

		return this._audioElements[src];
	}

	async attachSinkId(src, sinkId) {
		try {
			(this.element(src) as any)
				.setSinkId(sinkId)
				.then((s) => {
					console.log('Set Sink ID for');
				})
				.catch((error) => {
					console.error('Failed to set Sink ID for', error);
				});
		} catch (error) {
			console.log('sinkId err', error);
		}
	}

	private createElement(src: string) {
		this._audioElements[src] = document.body.appendChild(new Audio(src));
	}

	public removeAudioElement(src: string): void {
		this._audioElements[src].src = null;
		this._audioElements[src].remove();
	}
}
